import ApiClient from '../api/ApiClient';
import ApplicationService from './ApplicationService';
import AuthService from './AuthService';
import Authenticator from './Authenticator';
import ContactFormService from './ContactFormService';
import ManagementService from './ManagementService';
import ServerService from './ServerService';
import UserProfileService from './UserProfileService';
export default class ServiceLocator {

    public static ApiClient: ApiClient = new ApiClient();
    public static Authenticator: Authenticator = new Authenticator();
    public static AuthService: AuthService = new AuthService();
    public static UserProfileService: UserProfileService = new UserProfileService();
    public static ApplicationService: ApplicationService = new ApplicationService();
    public static ManagementService: ManagementService = new ManagementService();
    public static ServerService: ServerService = new ServerService();
    public static ContactFormService: ContactFormService = new ContactFormService();

}